<form [formGroup]="generalForm">
  <div *ngIf="account_type == 'broker'">
    <div class="row">
      <div class="col-8">
        <div class="form-section">
          <div class="mb-3">
            <label for="broker_reference" class="form-label">{{
              "inputs.reference" | translate
            }}</label>
            <div class="input-group div-copy">
              <input
                type="text"
                class="form-control"
                id="broker_reference"
                #inputBrokerReference
                formControlName="broker_reference"
                placeholder="{{ 'inputs.reference' | translate }}"
                required
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary copy"
                  type="button"
                  (click)="copyToClipboard(inputBrokerReference.value, $event)"
                >
                  <i class="icon-copy"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="form-section">
          <div class="mb-3">
            <label for="broker_agent_id" class="form-label">{{
              "inputs.broker_agent" | translate
            }}</label>
            <ng-select
              formControlName="broker_agent_id"
              [items]="agentData"
              bindValue="reference"
              [placeholder]="'inputs.select_option' | translate"
              [searchable]="true"
              [clearable]="false"
              [notFoundText]="'tables.no_results' | translate"
            >
              <ng-template ng-label-tmp let-item="item">
                {{ item.name }} {{ item.lastname }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ item.name }} {{ item.lastname }}
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--   <div class="row">
    <div class="col-6">
      <div class="mb-3">
        <label for="campaign" class="form-label">{{
          "inputs.campaign" | translate
          }}</label>
        <select id="campaign_id" class="form-control" formControlName="campaign_id"
          (ngModelChange)="changeCampaign($event)">
          <option *ngFor="let value of campaignsData" [value]="value.reference"
            [selected]="value.reference === ladata.campaign">
            {{ value.name }}
          </option>
        </select>
      </div>
    </div>
  </div> -->
  <!--  <input type="text" class="form-control mb-2" placeholder="Buscar campaña..." (input)="filterCampaigns($event)">
  <select id="campaign_id" class="form-control" formControlName="campaign_id"
    (change)="changeCampaign($event)">
    <option *ngFor="let value of filteredCampaigns" [value]="value.reference">
      {{ value.name }}
    </option>
  </select> -->

  <div class="col-12">
    <div class="mb-5 buscador d-block">
      <label for="campaign" class="form-label"
        >{{ "inputs.campaign" | translate }}
        <span class="required">*</span></label
      >
      <div class="client-selector">
        <div class="main-selector-container">
          <div
            class="selector-container-supplier"
            [ngClass]="{ expanded: optionsVisibleCampaign }"
          >
            <input
              type="text"
              (focus)="onFocus('campaign')"
              (blur)="hideOptions()"
              placeholder="{{ 'inputs.campaign' | translate }}"
              (input)="searchCampaigns($event.target)"
              [value]="displayTextCampaign"
            />
            <input type="hidden" formControlName="campaign_id" />
            <span class="icon-chevron-down arrow"></span>
          </div>
          <div
            class="options-container"
            *ngIf="optionsVisibleCampaign"
            [ngClass]="{ visible: optionsVisibleCampaign }"
          >
            <div
              class="option-value"
              *ngFor="let campaign of filteredCampaigns"
              (mousedown)="onSelectCampaign(campaign)"
            >
              <div>{{ campaign.supplier_name }} - {{ campaign.name }}
                <span *ngIf="getMinFee(campaign) as minFee" class="campaign-min-fee">{{ "inputs.from" | translate }} {{ minFee | number:'1.2-2' }}€/{{ "tables.month" | translate }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="newCampaign">
    <div class="row linea"></div>
    <div class="row">
      <div class="col-5">
        <div class="mb-3">
          <div class="column-list">
            <span
              *ngIf="campaign?.units"
              class="badge text-badge-list badge-units"
              [ngClass]="'units' | badgeVehicle"
              >{{ campaign?.virtual_available_units }}
              {{ "inputs.availables" | translate
              }}<span class="info-icon" tabindex="0">
                <i class="icon-notification"></i>
                <span class="tooltip">{{
                  "inputs.i.virtual_available_units" | translate
                }}</span>
              </span>
            </span>

            <span
              *ngIf="campaign?.units"
              class="badge text-badge-list badge-units2"
              [ngClass]="'units' | badgeVehicle"
              >{{ campaign?.units }}
              {{ "inputs.total_units" | translate }}</span
            >

            <span *ngIf="campaign?.vehicle_brand">
              {{ campaign?.vehicle_brand }} {{ campaign?.vehicle_model }}
              <span *ngIf="campaign?.vehicle_trim">{{ campaign?.vehicle_trim }}</span>
              {{ campaign?.vehicle }} ({{ campaign?.vehicle_model_year }})
            </span>
            <div class="vehicle-line">
              <span
                *ngIf="campaign?.type"
                class="badge text-badge-list"
                [ngClass]="campaign.type | badgeVehicle"
                >{{
                  "badge-status_select-stage." + campaign?.type | translate
                }}</span
              >
              <span
                *ngIf="campaign?.vehicle_status"
                class="badge text-badge-list"
                [ngClass]="campaign.vehicle_status | badgeVehicle"
                >{{
                  "badge-status_select-stage." + campaign?.vehicle_status
                    | translate
                }}</span
              >
            </div>

            <span *ngIf="campaign?.colour" class="secondary-text">
              <i class="icon-brush2"></i> {{ campaign?.colour }}</span
            >
          </div>

          <div class="column-list">
            <span class="secondary-text">
              <i
                [ngClass]="
                  campaign?.include_insurance
                    ? 'icon-check text-success'
                    : 'icon-cross2 text-danger'
                "
              ></i>
              {{ "helper.include_insurance" | translate }}</span
            >
            <span class="secondary-text">
              <i
                [ngClass]="
                  campaign?.include_maintenance
                    ? 'icon-check text-success'
                    : 'icon-cross2 text-danger'
                "
              ></i>
              {{ "helper.include_maintenance" | translate }}</span
            >
            <span class="secondary-text">
              <i
                [ngClass]="
                  campaign?.include_replacement_vehicle
                    ? 'icon-check text-success'
                    : 'icon-cross2 text-danger'
                "
              ></i>
              {{ "helper.include_replacement_vehicle" | translate }}</span
            >
            <span class="secondary-text">
              <i
                [ngClass]="
                  campaign?.include_tires
                    ? 'icon-check text-success'
                    : 'icon-cross2 text-danger'
                "
              ></i>
              {{ "helper.include_tires" | translate }}</span
            >
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="mb-3">
          <div class="column-list">
            <span *ngIf="campaign?.supplier_name">
              {{ campaign?.supplier_name }} </span
            ><br />
            <span *ngIf="campaign?.vendor_name">
              {{ campaign?.vendor_name }} </span
            ><br />
            <span *ngIf="campaign?.start_date">
              <i class="icon-play-circle"></i>
              {{ "forms.labels.start" | translate }} {{ campaign?.start_date }}
            </span>
            <span *ngIf="campaign?.end_date">
              <i class="icon-stop-circle"></i>
              {{ "forms.labels.end" | translate }} {{ campaign?.end_date }}
            </span>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="mb-3">
          <div class="column-list">
            <span class="comment text-secondary" *ngIf="campaign?.comments">
              {{ campaign?.comments }}</span
            ><br />
            <span
              class="comment text-secondary"
              *ngIf="campaign?.delivery_comments"
            >
              {{ campaign?.delivery_comments }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="row linea"></div>
    <div class="col-12">
      <div class="d-flex align-items-center justify-content-end">
        <input
          #customConfigCheckbox
          class="form-check-input"
          type="checkbox"
          id="custom_config"
          (change)="onCheckboxChange2($event)"
        />
        <label class="form-check-label" for="custom_config">
          {{ "forms.buttons.custom_config" | translate }}
        </label>
      </div>
      <div class="row" [hidden]="!customConfig">
        <div class="col-6">
          <div class="mb-3">
            <label for="duration" class="form-label">{{
              "inputs.duration" | translate
            }}</label>
            <ng-select
              formControlName="duration"
              [items]="durationOptions"
              [placeholder]="'inputs.select_option' | translate"
              [searchable]="true"
              [clearable]="false"
              [notFoundText]="'tables.no_results' | translate"
            >
              <ng-template ng-label-tmp let-item="item">
                {{ item }} {{ "inputs.month" | translate }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ item }} {{ "inputs.month" | translate }}
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-6">
          <div>
            <div class="mb-3">
              <label for="yearly_kms" class="form-label">{{
                "inputs.yearly_kms" | translate
              }}</label>
              <ng-select
                formControlName="yearly_kms"
                [items]="yearlyKmsOptions"
                [placeholder]="'inputs.select_option' | translate"
                [searchable]="true"
                [clearable]="false"
                [notFoundText]="'tables.no_results' | translate"
              >
              </ng-select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12" [hidden]="customConfig">
      <div class="mb-3">
        <label for="price_matrix" class="form-label">{{
          "inputs.price_matrix" | translate
        }}</label>
        <div
          class="d-flex justify-content-start align-items-center"
          [class.table-disabled]="isDisabled"
          [attr.aria-disabled]="isDisabled"
        >
          <table class="matriz">
            <thead>
              <tr>
                <th class="cell-no-border"></th>
                <th *ngFor="let col of columns">
                  {{ col }}
                  <span class="text-sm">{{ "inputs.month" | translate }}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of rows">
                <th>
                  {{ row | formatNumberPipe3 }}
                  <span class="text-sm">{{
                    "inputs.kilometers" | translate
                  }}</span>
                </th>
                <td *ngFor="let col of columns">
                  <button
                    [disabled]="isDisabled"
                    (click)="handleClick(col, row)"
                    [ngClass]="{
                      selected: selectedOpt && col === colKey && row === rowKey,
                    }"
                  >
                    <span *ngIf="matrix_total[col]?.[row]">
                      {{ matrix_total[col]?.[row] | formatNumberPipe
                      }}<span class="text-sm">{{
                        matrix_total[col]?.[row] | formatNumberPipe2
                      }}</span></span
                    >
                    <span *ngIf="!matrix_total[col]?.[row]"> - </span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="mt-2">
          <input
            #ivaCheckbox
            class="form-check-input"
            type="checkbox"
            value=""
            id="iva_included"
            (change)="onCheckboxChange($event)"
            checked
          />
          <label class="form-check-label" for="iva_included">
            {{ "forms.buttons.iva_included" | translate }}
          </label>
        </div>
      </div>
    </div>
  </div>
</form>
